export default "<ion-app>\n  <ion-router-outlet mode=\"md\"></ion-router-outlet>\n</ion-app>\n";